import React, { forwardRef } from 'react';
import { Button, IButtonProps } from '../Button/Button';
import { LINK_VARIANTS, LinkVariant } from '../Button/buttonVariants';

export interface ILinkButtonProps extends Omit<IButtonProps, 'variant'> {
  /**
   * @deprecated EORA V2 use linkPrimary/linkAccent/linkDark/linkWhite
   */
  light?: boolean;
  /**
   * @deprecated EORA V2 use linkPrimary/linkAccent/linkDark/linkWhite
   */
  dark?: boolean;
  variant?: Exclude<LinkVariant, 'link'>;
}

const calculateVariant = (light?: boolean, dark?: boolean, variant?: LinkVariant) => {
  if (dark) return LINK_VARIANTS.LINK_DARK;
  if (light) return LINK_VARIANTS.LINK_WHITE;
  return variant ?? LINK_VARIANTS.LINK_PRIMARY;
};

export const LinkButton = forwardRef<HTMLButtonElement, ILinkButtonProps>(({ light, dark, variant, ...rest }, ref) => {
  return <Button ref={ref} variant={calculateVariant(light, dark, variant)} {...rest} />;
});
